/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'
import 'owl.carousel'
import Swiper from 'swiper'
import lightGallery from 'lightgallery'
// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import { Navigation, Pagination } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
import { initProductDropdown } from './functions/product-dropdown'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/elephant_materials_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function () {

	jQuery(document).foundation();
	triggerThemeFunctions();
	initProductDropdown();

	// Shop filters: auto-submit on change and collapsible panels
	var productsCarousel = new Swiper('#products-carousel.swiper-container', {
		direction: 'horizontal',
		slidesPerView: 1,
		slidesPerColumn: 1,
		spaceBetween: 30,
		watchSlidesVisibility: true,
		observer: true,
		observeParents: true,
		loop: true,
		autoHeight: true,
		autoWidth: true,
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 30,

			},
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
		on: {
			init: function () {
				setTimeout(function () {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
		pagination: {
			el: ".swiper-pagination",
			type: "bullets",
			clickable: true
		},
	});

	var productsCarouselTwo = new Swiper('.carousel-columns-5.swiper-container', {
		direction: 'horizontal',
		slidesPerView: 1,
		slidesPerColumn: 1,
		spaceBetween: 30,
		watchSlidesVisibility: true,
		observer: true,
		observeParents: true,
		loop: true,
		autoHeight: true,
		autoWidth: true,
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 30,

			},
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
		},
		on: {
			init: function () {
				setTimeout(function () {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
		pagination: {
			el: ".swiper-pagination",
			type: "bullets",
			clickable: true
		},
	});


	var hero = new Swiper('#hero.swiper-container', {
		direction: 'horizontal',
		slidesPerView: 1,
		slidesPerColumn: 1,
		spaceBetween: 30,
		watchSlidesVisibility: true,
		observer: true,
		observeParents: true,
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 30,

			},
			1024: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
		},
		on: {
			init: function () {
				setTimeout(function () {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
		pagination: {
			el: ".swiper-pagination",
			type: "bullets",
			clickable: true
		},
	});

	let $lgSwiper = document.getElementById('lg-swipper');

	if ($lgSwiper) {
		var mainImagesSwiper = new Swiper('.galley-product-swiper', {
			direction: 'horizontal',
			spaceBetween: 20,
			slidesPerView: 1,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			loop: true,
			breakpoints: {
				640: { slidesPerView: 1 },
				1024: { slidesPerView: 1 },
				1200: { slidesPerView: 1 },
				1440: { slidesPerView: 1 }
			},
			on: {
				init: function () {
					const lg = lightGallery($lgSwiper, {
						selector: 'a',
						plugins: [lgThumbnail, lgZoom],
						speed: 500,
						download: false
					});
					$lgSwiper.addEventListener('lgBeforeClose', () => {
						mainImagesSwiper.slideTo(lg.index, 0);
					});
				}
			}
		});

		var thumbnailsSwiper = new Swiper('.galley-product-thumbs-swiper', {
			direction: 'vertical',
			spaceBetween: 10,
			loop: false,
			slidesPerView: 4
		});

		thumbnailsSwiper.on('click', function () {
			var clickedIndex = thumbnailsSwiper.clickedIndex;
			if (clickedIndex !== undefined) {
				mainImagesSwiper.slideTo(clickedIndex);
			}
		});

		mainImagesSwiper.on('slideChange', function () {
			var activeIndex = mainImagesSwiper.activeIndex;
			thumbnailsSwiper.slideTo(activeIndex);
		});

		// Also enable LightGallery on the main slider so clicking big image opens lightbox
		const $lgMain = document.querySelector('.galley-product-swiper');
		if ($lgMain) {
			lightGallery($lgMain, {
				selector: 'a',
				plugins: [lgThumbnail, lgZoom],
				speed: 500,
				download: false
			});
		}

	} // end if ($lgSwiper)

	var inquiryBtn = document.querySelector('.send-inquiry') || null;
	var inquiryModal = document.getElementById('inquiry-modal') || null;
	var closeBtn = document.getElementById('close-inquiry-modal') || null;
	var openBtn = document.querySelector('.inquiry-modal') || null;

	if (inquiryBtn) {
		inquiryBtn.addEventListener('click', function (e) {

			// Get product details
			var productTitle = document.querySelector('.product_title.entry-title')?.innerText || '';
			var productPrice = document.querySelector('.woocommerce-Price-amount.amount bdi .integerPart')?.innerText || '';
			var productPriceCents = document.querySelector('.woocommerce-Price-amount.amount bdi .price-cents')?.innerText || '';

			// Set hidden fields in the form
			document.getElementById('product_title').value = productTitle;
			document.getElementById('product_price').value = '$' + productPrice + '.' + productPriceCents;
			document.getElementById('product_permalink').value = window.location.href;
		});
	}

	if (closeBtn && inquiryModal) {
		closeBtn.addEventListener('click', function () {
			inquiryModal.style.display = 'none';
		});
	}

	if (openBtn && inquiryModal) {
		openBtn.addEventListener('click', function () {
			inquiryModal.style.display = 'flex';
		});
	}
	if (inquiryModal) {
		document.addEventListener('wpcf7mailsent', function (event) {
			if (inquiryModal.contains(event.target)) {
				inquiryModal.style.display = 'none';
				alert('Thank you for your inquiry! We will get back to you as soon as possible.');
			}
		});
	}

	var forms = document.querySelectorAll('.product-filters');
	if (!forms.length) return;
	forms.forEach(function (form) {
		// Auto-submit on checkbox change
		form.addEventListener('change', function (e) {
			if (!e.target || !e.target.name) return;
			if (e.target.name === 'cats[]' || e.target.name === 'brand_ids[]') {
				form.submit();
			}
		});

		// Slide animation helper
		function slide(panel, expand) {
			if (!panel) return;
			panel.style.overflow = 'hidden';
			if (expand) {
				panel.style.display = 'block';
				var target = panel.scrollHeight;
				panel.style.height = '0px';
				panel.getBoundingClientRect();
				panel.style.transition = 'height 250ms ease';
				panel.style.height = target + 'px';
				panel.addEventListener('transitionend', function te(e) {
					if (e.propertyName === 'height') {
						panel.style.transition = '';
						panel.style.height = 'auto';
						panel.style.overflow = '';
						panel.removeEventListener('transitionend', te);
					}
				});
			} else {
				var current = panel.scrollHeight;
				panel.style.height = current + 'px';
				panel.getBoundingClientRect();
				panel.style.transition = 'height 250ms ease';
				panel.style.height = '0px';
				panel.addEventListener('transitionend', function tc(e) {
					if (e.propertyName === 'height') {
						panel.style.transition = '';
						panel.style.display = 'none';
						panel.style.overflow = '';
						panel.removeEventListener('transitionend', tc);
					}
				});
			}
		}

		// Toggle panels on title click with arrow rotation via aria-expanded
		form.addEventListener('click', function (e) {
			var btn = e.target.closest('.filter-toggle');
			if (!btn || !form.contains(btn)) return;
			var panelId = btn.getAttribute('aria-controls');
			var panel = document.getElementById(panelId);
			if (!panel) return;
			var expanded = btn.getAttribute('aria-expanded') === 'true';
			btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
			slide(panel, !expanded);
		});

		// Initialize all panels based on aria-expanded
		form.querySelectorAll('.filter-toggle').forEach(function (btn) {
			var panel = document.getElementById(btn.getAttribute('aria-controls'));
			if (!panel) return;
			if (btn.getAttribute('aria-expanded') === 'true') {
				panel.style.display = 'block';
				panel.style.height = 'auto';
			} else {
				panel.style.display = 'none';
				panel.style.height = '0px';
			}
		});
	});

}); // end DOMContentLoaded



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions() {
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function () {
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();

	// ---------- Woo: format price cents as small superscript on single product ----------
	(function formatSingleProductPriceCents() {
		var price = document.querySelector('.summary .price .amount bdi');
		if (!price) return;
		var html = price.innerHTML; // contains currency span + number, e.g. <span class="woocommerce-Price-currencySymbol">$</span>159.99
		var re = /(.*<\/span>\s*)(\d+)([\.,](\d{2}))/; // groups: 1=symbol span, 2=int, 3=.99, 4=99
		var m = html.match(re);
		if (m) {
			var symbolSpan = m[1];
			var integerPart = m[2];
			var cents = m[4];
			price.innerHTML = symbolSpan + '<span class="integerPart">' + integerPart + '</span><span class="price-cents">' + cents + '</span>';
		}
	})();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */